<h2 mat-dialog-title>
  {{ text.title }}
</h2>
<mat-dialog-content>
  {{ text.message }}
  <ul *ngIf="text.list?.length">
    <li *ngFor="let item of text.list">{{ item }}</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between">
  <!-- Negative -->
  <button mat-button *ngIf="'basic' === text?.buttons?.negative?.style" [color]="text?.buttons?.negative?.colour ?? colour" (click)="dialogRef.close(false)">{{ text.buttons.negative?.text }}</button>
  <button mat-raised-button *ngIf="'raised' === text?.buttons?.negative?.style" [color]="text?.buttons?.negative?.colour ?? colour" (click)="dialogRef.close(false)">{{ text.buttons.negative?.text }}</button>

  <!-- Affirmative -->
  <button mat-button *ngIf="'basic' === text?.buttons?.affirmative?.style" [color]="text?.buttons?.affirmative?.colour ?? colour" (click)="dialogRef.close(true)">{{ text.buttons.affirmative?.text }}</button>
  <button mat-raised-button *ngIf="'raised' === text?.buttons?.affirmative?.style" [color]="text?.buttons?.affirmative?.colour ?? colour" (click)="dialogRef.close(true)">{{ text.buttons.affirmative?.text }}</button>
</mat-dialog-actions>